import { ElementRef, ViewChild, Directive } from '@angular/core';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { TerraUtils } from 'src/app/shared/TerraUtils';

@Directive()
export class DialogWithFormBase extends OnDestroyMixin {
  constructor() {
    super();
  }
  // A way to refer to a view element that has ngIf on it
  private serverError: ElementRef;
  @ViewChild('serverError') set content(content: ElementRef) {
    this.serverError = content;
    if (content && content.nativeElement) {
      TerraUtils.scrollToElement(content.nativeElement);
    }
  }
}
